import { useState } from "react";
import { useTranslation } from 'react-i18next';
import getProgressBarColor from "../../Utils/getProgressBarColor";
import DescriptionBanner from "../DescriptionBanner";
import DynamicTable from "../UI/DynamicTable";

export default function OrderDetailsTable({ orderData }) {
    const { t } = useTranslation();
    const [searchTerm, setSearchTerm] = useState("");
    // Filtro i dati in base all’email
    const filteredData = orderData?.filter((row) =>
        row?.codice_attivazione?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    return (
        <div className="w-full mx-auto bg-[#F3F4F7] p-7 rounded-md border-black">
            <div className={'mt-0'}>
                <DynamicTable
                    data={filteredData}
                    customColumnsMap={[
                        {
                            field: 'codice_attivazione',
                            label: t('activationCode'),
                            width: 'w-48'
                        },
                        {
                            field: 'numero_endpoint_utilizzati',
                            label: t('endpointsUsed'),
                            width: 'w-48'
                        },
                        {
                            field: 'numero_endpoint_massimo',
                            label: t('endpointsMax'),
                            width: 'w-48'
                        },
                        {
                            label: t('usageRate'),
                            width: 'w-48',
                            align: 'left',
                            render: (row) => (
                                <div className="flex gap-2 items-center">
                                    <div>
                                        {Math.round((row.numero_endpoint_utilizzati / row.numero_endpoint_massimo) * 100)}%
                                    </div>
                                    <div className="w-full gap-2 bg-gray-300 h-3 rounded">
                                        <div
                                            className={`${getProgressBarColor(Math.round((row.numero_endpoint_utilizzati / row.numero_endpoint_massimo) * 100))} h-3 rounded`}
                                            style={{ width: `${Math.round((row.numero_endpoint_utilizzati / row.numero_endpoint_massimo) * 100) || 0}%` }}
                                        ></div>
                                    </div>
                                </div>
                            )
                        },
                    ]}
                    searchTerm={searchTerm}
                    onSearchChange={setSearchTerm}
                    enableRowSelection={false}
                    showSearchBar={true}
                    maxHeight="40rem"
                />
            </div>
        </div>
    );
}


